import React, { useEffect, useState, useContext, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useMeasure from 'react-use-measure'
import Header from '@/partials/Header'
import Sidebar from '@/partials/Sidebar'
import Footer from '@/partials/Footer'
import Chat from '@/partials/Chat'
import BottomNavigation from '@/partials/BottomNavigation'
import { ChatAlt2Icon } from '@heroicons/react/solid'
import { classNames } from '@/utils/classNames'
import { AuthContext } from '../contexts/AuthContext'
import { BiSupport } from "react-icons/bi";

export default function Layout({ children, chat }) {
  const { user, auth } = useContext(AuthContext);
  const [body, setBody] = useState(null)
  const [ref, bounds] = useMeasure()
  const router = useNavigate()
  const { search } = useLocation();
  const scrollRef = useRef()

  useEffect(() => {
    if (!document) return
    setBody(document.querySelector('body'))
  }, [])

  useEffect(() => {
    if (!body) return

    if (bounds?.width && bounds?.width < 1000) {
      body.classList.add('dark')
    } else {
      body.classList.remove('dark')
    }
  }, [body, bounds?.width])

  useEffect(() => {
    if (user?.createdAt && !user?.username && auth && auth.uid && auth.isLoaded && !auth.isEmpty) {
      setTimeout(() => {
        router({ search: '?modal=setUsername' })
      }, 500)
    }
  }, [router, user, search])

  useEffect(() => {
    scrollRef.current.scrollTo(0, 0)
  }, [router]);

  return (
    // <div className="min-h-screen lg:h-screen bg-gradient-to-t from-gray-900 to-gray-800 w-full overflow-x-hidden text-white flex pb-16 lg:pb-0 text-sm relative font-sans">
    //   <div ref={scrollRef} className="flex-1 overflow-x-hidden flex flex-col">
    //     <Header />
    //     <main className="mt-16 lg:mt-0 flex flex-1" ref={ref}>
    //       <div className="h-full"><Sidebar /></div>
    //       <div className="flex-1">
    //       {children}
    //       </div>
    //     </main>
    //     <Footer />
    //   </div>
    //   <Chat />
    //   <BottomNavigation />
    //   <button className={classNames('hidden md:block fixed z-50 border border-gray-800 bottom-4 bg-gray-900 hover:bg-gray-800 rounded-full p-3 shadow-2xl transition-all duration-500', chat ? 'right-96 mr-4' : 'right-4')} id="custom-intercom">
    //     <ChatAlt2Icon className="h-8 w-8" />
    //   </button>
    // </div>
    <div className="min-h-screen flex text-sm lg:h-screen overflow-hidden text-white font-sans bg-gray-900">
      <div ref={scrollRef} className="min-h-screen pb-16 flex flex-col lg:h-screen overflow-hidden font-sans text-white w-full">
        <Header />
        <div className="flex h-full">
          <Sidebar />
          <main className="flex-1 flex flex-col bg-gray-800 h-full overflow-auto rounded-t-lg" style={{marginRight: -7}} ref={ref}>
            <div className="pb-4 flex-1">
              {children}
            </div>
            <Footer />
          </main>
          <Chat />
        </div>
      </div>
      {/* <Chat /> */}
      <BottomNavigation />
      <button className={classNames('hidden md:block fixed z-50 border border-gray-800 bottom-4 bg-gray-900 hover:bg-purple-600 rounded-full p-2.5 shadow-2xl transition-all duration-500', chat ? 'right-96 mr-2' : 'right-4')} id="custom-intercom">
        <BiSupport className="h-6 w-6" />
      </button>
    </div>
  )
}
